"use strict";

import React from 'react';
import PropTypes from 'prop-types';
import AppStore from '../stores/AppStore';
import Spinner from './ui/Spinner2.react';
import MigrationExitButton from './MigrationExitButton.react';

/**
 * Web 10: the transfer to Rakuten TV is still running.
 *
 * The copy is for arriving at /migrate on a transfer that is already running.
 * While the request from this visit's own "Transfer now" click is still on its
 * way to an outcome, `loading` holds a spinner here instead.
 */
export default class MigrationInProgress extends React.Component {
    static propTypes = {
        loading: PropTypes.bool,
    };

    static defaultProps = {
        loading: false,
    };

    render() {
        if (this.props.loading) {
            return (
                <div className="account-migration__loading" aria-busy="true">
                    <Spinner />
                </div>
            );
        }

        return (
            <div className="migration-outcome-overlay">
                <h1 className="migration-outcome-overlay__lead">
                    {AppStore.translate('view.migration_overlay.web10.title')}
                </h1>
                <div className="overlay-content migration-outcome-overlay__content">                                        
                    <p>{AppStore.translate('view.migration_overlay.web10.body')}</p>
                    <MigrationExitButton label={AppStore.translate('view.migration_overlay.web10.back_cta')} />
                </div>
            </div>
        );
    }
}
